import React, { useCallback, useMemo } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { guid } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { Calendar } from '../../../common/icons';
import { SelectInput } from '../../../components/select/components/SelectInput';
import { RcPopover } from '../../../units/popover-wrapper';
export function PopperWrapper(props) {
  var _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      placeholder = props.placeholder,
      onShow = props.onShow,
      onHide = props.onHide,
      show = props.show,
      onVisibleChange = props.onVisibleChange,
      triggerType = props.triggerType,
      children = props.children,
      width = props.width,
      _props$datasource = props.datasource,
      datasource = _props$datasource === void 0 ? [] : _props$datasource,
      onClear = props.onClear,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? true : _props$clearable,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$readOnly = props.readOnly,
      readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
      renderTrigger = props.renderTrigger,
      renderPlaceholder = props.renderPlaceholder,
      renderSelected = props.renderSelected,
      className = props.className,
      wrapperClassName = props.wrapperClassName,
      _props$filled = props.filled,
      filled = _props$filled === void 0 ? false : _props$filled,
      _props$htmlReadOnly = props.htmlReadOnly,
      htmlReadOnly = _props$htmlReadOnly === void 0 ? false : _props$htmlReadOnly;
  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  var placeholderInputCls = usePrefixCls('date-picker-input-placeholder');
  var onClearCallback = useRefCallback(onClear);
  var handleClear = useCallback(function (val) {
    if (!val) {
      onClearCallback();
    }
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(SelectInput, {
    show: show,
    invalid: invalid,
    triggerId: triggerId,
    triggerType: triggerType,
    suffix: React.createElement(Calendar, null),
    value: datasource.length ? datasource[0].label : '',
    className: placeholderInputCls,
    placeholder: placeholder,
    size: size,
    width: width,
    clearable: clearable,
    disabled: disabled,
    onValueChange: handleClear,
    readOnly: readOnly,
    filled: filled,
    renderPlaceholder: renderPlaceholder,
    renderSelected: renderSelected,
    unsetHeight: false,
    htmlReadOnly: htmlReadOnly
  }, renderTrigger ? renderTrigger(false) : null), React.createElement(RcPopover, {
    show: show,
    onVisibleChange: onVisibleChange,
    onShow: onShow,
    onHide: onHide,
    getPopper: function getPopper() {
      return children;
    },
    arrow: false,
    placement: placement,
    offset: {
      x: 0,
      y: 4
    },
    triggerIds: triggerIds,
    lazyInit: true,
    hideToDestroy: true,
    scaleAnimation: "y",
    className: className,
    wrapperClassName: wrapperClassName
  }));
}